<template>

  <div>

    <div v-if="!isPreForm">
      <b>{{selectedSubsidiary.title}}</b> / <b>{{selectedGroup.title}}</b><br/>
      <div v-if="selectedDate" class="mb-3">{{selectedDate.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedDate.date | moment('HH:mm')}} Uhr</div>
      {{ settings['appointmentgroup.default.frontend.heading.form'].value }}
      <hr/>
    </div>

    <div v-for="formelement in form" :key="formelement.key">

      <div :key="formValidateCount">

        <b-form-group
            v-if="formelement.type === 'input' && formelement.show"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-input @update="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="formelement.type == 'mobilephone' && formelement.show"
          label-cols-sm="6"
          label-cols-lg="6"
          :name="formelement.key"
          :label="formelement.label"
          :state="formStates[formelement.key]"
          :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
          :validated="formStates[formelement.key]"
        >
          <b-form-input @input="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
        </b-form-group>

        <b-form-group
            v-if="formelement.type === 'email' && formelement.show"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-input @input="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
        </b-form-group>

        <b-form-group
            v-if="formelement.type === 'textarea'"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-textarea @input="validateFormelement(formelement)" v-model="userInput[formelement.key]"></b-form-textarea>
        </b-form-group>

        <div class="mt-3 form-html-content" v-if="formelement.type === 'html'" v-html="formelement.config.content">
        </div>

        <b-form-group
            label-cols-sm="6"
            label-cols-lg="6"
            v-if="formelement.type === 'number' && formelement.show"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :validated="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
        >
          <b-form-input type="number" min="0" v-model="userInput[formelement.key]" @input="validateFormelement(formelement)"/>
        </b-form-group>


        <b-form-group
            v-if="!isPreForm && formelement.type === 'select' && (!formelement.config.has_appointment_filter || formelement.config.has_appointment_filter == 'false')"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
        >
          <b-form-radio
              v-for="option in formelement.config.options"
              v-model="userInput[formelement.key]"
              @change="validateFormelement(formelement, option)"
              :value="option"
              stacked
              :key="option.label"
          >
            {{ option.label }}
          </b-form-radio>

          <div class="mt-3" v-if="userInput[formelement.key] && userInput[formelement.key].content" v-html="nl2br(userInput[formelement.key].content)">
          </div>
        </b-form-group>


        <b-row v-if="isPreForm && formelement.type === 'select'  && formelement.config.has_appointment_filter">
          <b-col cols="12" md="6">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="12"
                :name="formelement.key"
                :label="formelement.label"
                :state="formStates[formelement.key]"
                :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            >
              <b-form-radio
                  v-for="option in formelement.config.options"
                  v-model="userInput[formelement.key]"
                  @change="validateFormelement(formelement, option)"
                  :value="option"
                  stacked
                  :key="option.label"
              >
                {{ option.label }}
              </b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <div v-if="userInput[formelement.key] && userInput[formelement.key].content" v-html="nl2br(userInput[formelement.key].content)"></div>
          </b-col>
        </b-row>

        <b-form-checkbox
            class="mt-3"
            size="xl"
            v-model="userInput[formelement.key]"
            :name="formelement.key"
            v-if="formelement.type === 'checkbox'"
            :state="formStates[formelement.key]"
            unchecked-value=""
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            @input="validateFormelement(formelement)">{{formelement.label}}</b-form-checkbox>

      </div>

    </div>

  </div>

</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BRow,
  BCol, BFormRadio
} from 'bootstrap-vue'

export default {
  name: "CustomerForm",
  components: {
    'b-row': BRow,
    'b-col': BCol,
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-form-checkbox': BFormCheckbox,
    'b-form-textarea': BFormTextarea,
    'b-form-radio': BFormRadio
  },
  props: ['settings', 'form', 'selectedDate', 'selectedSubsidiary', 'selectedGroup', 'isPreForm'],
  data () {
    return {
      userInput: {},
      formStates: {},
      formRules: {},
      formValidateCount: 0,
      formInvidualInvalidFeedback: []
    }
  },
  mounted() {
  },
  methods: {
    formInvalidFeedback(type, key) {
      if(key && this.formInvidualInvalidFeedback[key]) return this.formInvidualInvalidFeedback[key]
      if(type == 'input' || type == 'textarea') return 'Bitte füllen Sie dieses Feld aus'
      if(type == 'email') return 'Bitte geben Sie hier eine gültige E-Mail Adresse ein'
      if(type == 'select') return 'Bitte wählen Sie eine Option'
      if(type == 'checkbox') return 'Bitte bestätigen Sie dieses Feld'
      if(type == 'mobilephone') return 'Bitte geben Sie hier eine gültige Mobilnummer ein'
    },
    reset () {
      this.userInput = {}
      this.formStates = {}
    },
    validate () {

      let formIsValid = true

      for(const formelement of this.form) {
        if (formelement.key !== 'form_captcha' && !this.validateFormelement(formelement)) formIsValid = false
      }
      this.formValidateCount++

      return {
        userInput: this.userInput,
        isValid: formIsValid
      }

    },
    validateFormelement(formelement, optionSelect) {
      let validInput = true
      let validInputOverwrite = null

      if (formelement && formelement.config.validation_rules && formelement.config.validation_rules.indexOf('required') >= 0
          && formelement.show) {

        if (!this.userInput[formelement.key]) {
          validInput = false
        } else if (formelement.type === 'email') {
          const re = /\S+@\S+\.\S+/;
          validInput = re.test(this.userInput[formelement.key]);
        } else if (formelement.type === 'input' || formelement.type === 'textarea') {
          validInput = (this.userInput[formelement.key].length >= 3)
        } else if (formelement.type === 'checkbox') {
          validInput = this.userInput[formelement.key]
        } else if(formelement.type === 'mobilephone') {
          const re = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
          validInput = re.test(this.userInput[formelement.key])
        } else if(formelement.type === 'number') {
          const re = /^[0-9]+$/;
          validInput = re.test(this.userInput[formelement.key])
        }
      }

      if (formelement && formelement.config.validation_content && this.userInput[formelement.key] && this.userInput[formelement.key].length >= 3) {

        const expFound = new RegExp(formelement.config.validation_content.expression, 'gi').test(this.userInput[formelement.key].trim())
        if(validInput) {
          validInput = formelement.config.validation_content.type == 'allow' ? expFound : !expFound
          if(!validInput && formelement.config.validation_content.message != '') {
            this.formInvidualInvalidFeedback[formelement.key] = formelement.config.validation_content.message
          }
        }

        if(validInput && this.formInvidualInvalidFeedback[formelement.key]) delete this.formInvidualInvalidFeedback[formelement.key]
        if(!validInput && formelement.config.validation_content.continue) {
          validInputOverwrite = true
          // override settings?
          if(formelement.config.validation_content.override_settings && formelement.config.validation_content.settings_to_override) {
            for(const setting of formelement.config.validation_content.settings_to_override) {
                if(expFound) this.$emit('settings-override', setting)
                else this.$emit('settings-restore', setting)
            }
          }
        }

      }

      this.formStates[formelement.key] = validInput

      if (formelement && formelement.type === 'select') {
        let formelementLabel = null
        for (const element of this.form) {
          if (element.key === formelement.key && element.config.options.length > 0) {
            for (const option of element.config.options) {
              if (optionSelect && option.label === optionSelect.label) {
                formelementLabel = option.label
                if (formelement.config.has_appointment_filter && formelement.config.has_appointment_filter == 'true') {
                  if (option.appointment_filter && option.appointment_filter.length > 0) {
                    this.$emit('group-filter-change', option.appointment_filter)
                  }
                }
                break
              }
            }
          }
        }

        if (formelementLabel) {
          this.userInput[formelement.key + ':label'] = formelementLabel

          if(optionSelect.defaultLanguageLabel) {
            this.userInput[formelement.key + ':label.default.language'] = optionSelect.defaultLanguageLabel
          }
        }
        this.setShowElements({ ...optionSelect, key: formelement.key, type: 'select' })
      }
      this.setShowElements({ key: formelement.key, type: formelement.type })
      return validInputOverwrite ? validInputOverwrite : validInput
    },
    setShowElements(rule) {
      for(const key in this.form) {
        if(this.form[key].config && this.form[key].config.display_rules && this.form[key].config.display_rules[rule.key]) {
          const elementDisplayRules = this.form[key].config.display_rules
          let showElement = true

          for(const keyDisplayRule in elementDisplayRules) {
            if(elementDisplayRules[keyDisplayRule] === '' || typeof elementDisplayRules[keyDisplayRule] !== 'object' && this.userInput[keyDisplayRule] &&
                (this.userInput[keyDisplayRule].includes(elementDisplayRules[keyDisplayRule].replace('*', '')) || elementDisplayRules[keyDisplayRule] === '*')
            ) {
                continue
            } else if(typeof elementDisplayRules[keyDisplayRule] === 'object') {
              const existDisplayRuleSelect = elementDisplayRules[keyDisplayRule].find((el) => {
                return el === this.userInput[keyDisplayRule + ':label'] || el === this.userInput[keyDisplayRule + ':label.default.language'];
              });

              if(!existDisplayRuleSelect) {
                showElement = false
                break
              }
            } else {
              showElement = false
              break
            }
          }
          this.form[key].show = showElement
        }
      }
    },
    setErrors(errors) {

      for (let field in this.formStates) {
        this.formStates[field] = true
      }

      for (let error of errors) {
        this.formStates[error.field] = false
      }

      this.formValidateCount++

    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  }
}
</script>

<style scoped>

</style>
